import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from '@/components/forms/new/formikFormFields/NameField';

const CustomAttributeField = ({
    darkMode,
    errors,
    touched,
    attributeIndex,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const fieldName = `attribute${attributeIndex}`;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors[fieldName] && touched[fieldName]}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Custom Attribute {attributeIndex}
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enter a custom attribute value for this number block.
                    </Text>
                </Box>
                <Box flex="1" minWidth={0}>
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            id={fieldName}
                            name={fieldName}
                            placeholder={`Value for Attribute ${attributeIndex}`}
                            error={errors[fieldName]}
                        />
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter a custom attribute value for this number block (max 100 characters)."
                        ariaLabel={`custom-attribute-${attributeIndex}-tip`}
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

const CustomAttributeFields = ({ darkMode, errors, touched }) => {
    return (
        <>
            {[1, 2, 3].map((index) => (
                <CustomAttributeField
                    key={index}
                    darkMode={darkMode}
                    errors={errors}
                    touched={touched}
                    attributeIndex={index}
                />
            ))}
        </>
    );
};

export default CustomAttributeFields;
